import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import Cropper from 'cropperjs/dist/cropper.esm';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-file-edit-modal',
	templateUrl: './file-edit-modal.component.html',
	styleUrls: ['./file-edit-modal.component.scss']
})
export class FileEditModalComponent implements OnInit {
	@Input() file;
	@Input() allowedDimensions;
	@Input() isPopup;
	@Output() output = new EventEmitter<any>();
	@ViewChild('photo', { static: true }) photo: ElementRef;
	@ViewChild('thumbnail', { static: true }) thumbnail: ElementRef;
	cropper;
	listHeight = window.innerHeight * 0.63;
	allowedDimensionsArr;
	webComponentDomain = environment.webComponentUrl;

	constructor(private cd: ChangeDetectorRef) {}
	ngOnInit() {
		if (this.allowedDimensions) {
			this.allowedDimensionsArr = this.allowedDimensions.split('x');
		} else {
			this.allowedDimensionsArr = [this.file.dimensions[0], this.file.dimensions[1]];
		}

		this.allowedDimensionsArr = [Number(this.allowedDimensionsArr[0]), Number(this.allowedDimensionsArr[1])];
	}

	flip(type) {
		const data = this.cropper.getData();
		if (type === 'h') {
			this.cropper.scale(data.scaleX * -1, data.scaleY);
		} else {
			this.cropper.scale(data.scaleX, data.scaleY * -1);
		}
	}

	reset() {
		this.allowedDimensionsArr[0] = this.file.dimensions[0];
		this.allowedDimensionsArr[1] = this.file.dimensions[1];
		this.cropper.reset();
	}

	updateCanvas() {
		const width: number = Math.floor(Number(this.allowedDimensionsArr[0]));
		const height: number = Math.floor(Number(this.allowedDimensionsArr[1]));
		this.cropper.setCropBoxData({ width, height });
	}

	saveClose() {
		const width: number = Math.floor(Number(this.allowedDimensionsArr[0]));
		const height: number = Math.floor(Number(this.allowedDimensionsArr[1]));
		const canvas = this.cropper.getCroppedCanvas({ width, height, fillColor: '#fff' });

		canvas.toBlob((blob) => {
			const time = new Date().getTime();
			this.output.emit({
				method: 'saveClose',
				blob: blob,
				fileName: this.getNewFileName(width, height, time, this.file.name)
			});
		});
	}

	saveSelect() {
		const width: number = Math.floor(Number(this.allowedDimensionsArr[0]));
		const height: number = Math.floor(Number(this.allowedDimensionsArr[1]));

		const canvas: HTMLCanvasElement = this.cropper.getCroppedCanvas({
			width,
			height,
			fillColor: '#fff'
		});

		canvas.toBlob(
			(blob) => {
				const time = new Date().getTime();
				this.output.emit({
					method: 'saveSelect',
					blob: blob,
					fileName: this.getNewFileName(width, height, time, this.file.name)
				});
			},
			'image/jpeg',
			1
		);
	}

	getNewFileName(width: number, height: number, timeInMS: number, oldFileName: string): string {
		const regex = new RegExp(/(\d+)x(\d+)_(\d+)_/, 'gi');
		let newFileName = String();

		if (oldFileName.match(regex)) {
			newFileName = oldFileName.replace(regex, '');
		} else {
			newFileName = oldFileName;
		}

		return `${width}x${height}_${timeInMS}_${newFileName}`;
	}

	cancel() {
		this.output.emit({ method: 'cancel' });
	}

	onImageLoad(e: Event): void {
		const _this = this;
		const wrapper: HTMLElement = document.getElementById('editWrapper');

		this.cropper = new Cropper(this.photo.nativeElement, {
			viewMode: 1,
			aspectRatio: !!this.allowedDimensions ? Number(this.allowedDimensionsArr[0]) / Number(this.allowedDimensionsArr[1]) : NaN,
			preview: '.previewImage',
			zoomOnWheel: false,
			autoCrop: !this.allowedDimensions,
			cropBoxResizable: !this.allowedDimensions,
			dragMode: 'move',
			toggleDragModeOnDblclick: false,
			minContainerWidth: wrapper.clientWidth,
			minContainerHeight: this.listHeight,
			minCanvasWidth: this.photo.nativeElement.naturalWidth,
			minCanvasHeight: this.photo.nativeElement.naturalHeight,
			ready: function (event) {
				if (!this.autoCrop) {
					_this.cropper.crop();
				}

				const containerData: any = _this.cropper.getContainerData();
				const imageData: any = _this.cropper.getImageData();
				const canvasData: any = _this.cropper.getCanvasData();
				const cropBoxData: any = _this.cropper.getCropBoxData();
				const cropData: any = _this.cropper.getData();

				const left = (containerData.width - imageData.naturalWidth) / 2;
				_this.cropper.setCanvasData({
					left: left,
					top: 0,
					width: imageData.naturalWidth,
					height: imageData.naturalHeight
				});

				if (_this.allowedDimensions) {
					_this.cropper.setData({
						width: imageData.naturalWidth,
						height: imageData.naturalHeight
					});

					_this.cropper.setCropBoxData({
						width: Number(imageData.naturalWidth),
						height: Number(imageData.naturalHeight)
					});
				}
			},
			cropend: function (event) {
				const width: number = Math.floor(Number(_this.cropper.getCropBoxData().width));
				const height: number = Math.floor(Number(_this.cropper.getCropBoxData().height));
				_this.cropper.setCropBoxData({ width, height });
				_this.cropper.setData({ width, height });

				const containerData: any = _this.cropper.getContainerData();
				const imageData: any = _this.cropper.getImageData();
				const canvasData: any = _this.cropper.getCanvasData();
				const cropBoxData: any = _this.cropper.getCropBoxData();
				const cropData: any = _this.cropper.getData();
			}
		});
	}

	onImageError(error: Error): void {
		// console.log(`The image failed on crop. See details: ${error.message}`);
	}
}
